const MediaSlideArrow = ({
    direction,
    style,
    onClick
}) => (
    <i style={style} className={`global-icon icon-slim-arrow-${direction}`} onClick={onClick} />
);

export default MediaSlideArrow;